import React, { useState } from 'react';

const SettingsView = () => {
  const [inputValue1, setInputValue1] = useState('');
  const [inputValue2, setInputValue2] = useState('');

  const handleSave = () => {
    // Handle saving the input values
    console.log('Input 1:', inputValue1);
    console.log('Input 2:', inputValue2);
  };

  return (
    <div style={{ padding: 20 }}>
     <div style={{ marginBottom: 15 }}>
        <label htmlFor="Email" style={{ display: 'block', marginBottom: 5, fontWeight: '600', color: '#333' }}>Email</label>
        <input
          type="text"
          id="input1"
          value={inputValue1}
          onChange={(e) => setInputValue1(e.target.value)}
          style={{ width: '50%', padding: '10px', borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
        />
      </div>
      <div style={{ marginBottom: 20 }}>
        <label htmlFor="Password" style={{ display: 'block', marginBottom: 5, fontWeight: '600', color: '#333' }}>Password</label>
        <input
          type="text"
          id="input2"
          value={inputValue2}
          onChange={(e) => setInputValue2(e.target.value)}
          style={{ width: '50%', padding: '10px', borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
        />
      </div>
      <button
        onClick={handleSave}
        style={{
          backgroundColor: '#1976d2',
          color: '#fff',
          padding: '12px 20px',
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer',
          fontSize: 16,
          fontWeight: '600',
        }}
      >
        Save
      </button>
    </div>
  );
};

export default SettingsView;